import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import HomePage from '@/pages/home/page';
import LoginPage from '@/pages/login/page';
import AdminDashboard from '@/pages/dashboard/admin/page';
import TherapistDashboard from '@/pages/dashboard/therapist/page';
import TeacherDashboard from '@/pages/dashboard/teacher-dashboard/page';
import StudentListPage from '@/pages/dashboard/admin/students/page';
import TeacherListPage from '@/pages/dashboard/admin/teachers/page';
import AttendancePage from '@/pages/dashboard/admin/attendance/page';
import StaffAttendancePage from '@/pages/dashboard/admin/staff-attendance/page';
import SettingsPage from '@/pages/dashboard/admin/settings/page';
import AccessControlPage from '@/pages/dashboard/admin/access-control/page';
import SchoolCalendarPage from '@/pages/dashboard/admin/school-calendar/page';
import RouteGuard from '@/components/feature/RouteGuard';
import RoleHomeRedirect from '@/components/feature/RoleHomeRedirect';
import {
  ADMIN_DASHBOARD_ROUTE,
  TEACHER_DASHBOARD_ROUTE,
  THERAPIST_DASHBOARD_ROUTE,
  getRolesForRoute,
} from '@/router/roleRoutes';
import TeacherStudentsPage from '@/pages/dashboard/teacher-dashboard/students/page';
import TeacherAttendancePage from '@/pages/dashboard/teacher-dashboard/attendance/page';
import LessonPlanPage from '@/pages/dashboard/teacher-dashboard/lesson-plan/page';
import LessonPlansListPage from '@/pages/dashboard/teacher-dashboard/lesson-plans/page';

const ADMIN_DASHBOARD_ROLES = getRolesForRoute(ADMIN_DASHBOARD_ROUTE);
const TEACHER_DASHBOARD_ROLES = getRolesForRoute(TEACHER_DASHBOARD_ROUTE);
const THERAPIST_DASHBOARD_ROLES = getRolesForRoute(THERAPIST_DASHBOARD_ROUTE);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: ADMIN_DASHBOARD_ROUTE,
    element: (
      <RouteGuard feature="dashboard" allowedRoles={ADMIN_DASHBOARD_ROLES}>
        <AdminDashboard />
      </RouteGuard>
    ),
  },
  {
    path: '/dashboard/admin/students',
    element: <RouteGuard feature="students"><StudentListPage /></RouteGuard>,
  },
  {
    path: '/dashboard/admin/teachers',
    element: <RouteGuard feature="teachers"><TeacherListPage /></RouteGuard>,
  },
  {
    path: '/dashboard/admin/attendance',
    element: <RouteGuard feature="attendance"><AttendancePage /></RouteGuard>,
  },
  {
    path: '/dashboard/admin/staff-attendance',
    element: <RouteGuard feature="staffAttendance"><StaffAttendancePage /></RouteGuard>,
  },
  {
    path: '/dashboard/admin/settings',
    element: <RouteGuard feature="settings"><SettingsPage /></RouteGuard>,
  },
  {
    path: '/dashboard/admin/access-control',
    element: <RouteGuard feature="accessControl"><AccessControlPage /></RouteGuard>,
  },
  {
    path: '/dashboard/admin/school-calendar',
    element: <RouteGuard feature="schoolCalendar"><SchoolCalendarPage /></RouteGuard>,
  },
  {
    path: THERAPIST_DASHBOARD_ROUTE,
    element: (
      <RouteGuard feature="dashboard" allowedRoles={THERAPIST_DASHBOARD_ROLES}>
        <TherapistDashboard />
      </RouteGuard>
    ),
  },
  {
    path: TEACHER_DASHBOARD_ROUTE,
    element: (
      <RouteGuard feature="dashboard" allowedRoles={TEACHER_DASHBOARD_ROLES}>
        <TeacherDashboard />
      </RouteGuard>
    ),
  },
  {
    path: '/dashboard/teacher-dashboard/students',
    element: <RouteGuard feature="students"><TeacherStudentsPage /></RouteGuard>,
  },
  {
    path: '/dashboard/teacher-dashboard/attendance',
    element: <RouteGuard feature="attendance"><TeacherAttendancePage /></RouteGuard>,
  },
  {
    path: '/dashboard/teacher-dashboard/lesson-plan',
    element: <RouteGuard feature="lessonPlan"><LessonPlanPage /></RouteGuard>,
  },
  {
    path: '/dashboard/teacher-dashboard/lesson-plans',
    element: <RouteGuard feature="lessonPlan"><LessonPlansListPage /></RouteGuard>,
  },
  {
    path: '/dashboard',
    element: <RoleHomeRedirect />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;